<template>
  <div class="link-account">
    <div class="no-account">
      <h6>
        Do not have at least one Autonomous System Number (ASN) with APNIC?
      </h6>
      <p>
        We're sorry, but if you do not have at least one ASN with APNIC, this
        service is not for you.
      </p>
    </div>
    <div class="have-account">
      <h6>
        Already have at least one Autonomous System Number (ASN) with APNIC?
      </h6>
      <p>
        Request your APNIC Login and a member account to be linked. Your request
        will be sent to all Corporate Contacts and if approved, the dashboard
        will show data for your network.
      </p>
      <div class="button-wrapper">
        <a
          class="btn btn-primary"
          href="https://resources.apnic.net/auth/nm-landing-page.html"
          >Link existing membership <fa icon="external-link-alt"
        /></a>
      </div>
      <p>
        If you already made the request, then you need to wait until it is
        approved.
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.link-account {
  display: flex;
  flex-wrap: wrap;

  & > div {
    flex: 1;
    padding: 32px 16px;
    min-width: 300px;
    text-align: center;
    max-width: 550px;
  }

  .no-account {
    border-right: 1px solid black;

    @media screen and (max-width: 879px) {
      border: none;
      border-bottom: 1px solid black;
    }
  }
}

h6 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 40px;
}
.button-wrapper {
  margin: 40px 0;
}
p {
  line-height: 24px;
}
</style>
